import { appContent } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4 whitespace-nowrap">
              下拉式阅读体验
            </span>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-4">{appContent.title}</h2>
            <p className="text-sm md:text-base text-foreground-600 mb-6">{appContent.subtitle}</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-lg mx-auto lg:mx-0">
              {appContent.features.map((f, i) => (
                <div key={i} className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center shrink-0">
                    <i className="ri-check-line text-accent-500 text-sm"></i>
                  </div>
                  <span className="text-xs md:text-sm text-foreground-700">{f}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[360px]">
            <div className="w-full aspect-[9/16] rounded-lg overflow-hidden bg-background-100 shadow-sm">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20phone%20mockup%20showing%20Korean%20manhwa%20reading%20app%20interface%2C%20vertical%20scrolling%20comic%20reader%20with%20beautiful%20manhwa%20artwork%20visible%2C%20clean%20modern%20UI%20with%20warm%20tones%2C%20night%20mode%20reading%20screen%2C%20smartphone%20frame%2C%20elegant%20presentation&width=720&height=1280&seq=app-mobile-mockup&orientation=portrait"
                alt="韩漫网下拉式阅读移动端体验"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}